import { BackendModel, BackendService } from "../../core/backend.service";

export class OperacionProducto extends BackendModel{

    fecha: Date;
    cliente: String;
    estado: boolean;
    cantidad: number;

    constructor(protected backendService: BackendService, model?: OperacionProducto) {
        super(backendService, model);
      }
}



// WEBPACK FOOTER //
// ./src/app/productos/cantidad-total/operacion-producto.component.ts